import React, { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import AdminContext from '../../../StateContext/Application'
import "./bill.css";
import "./rejectpanel.css";
import { Back32, Cancel32, ProposalCreation32, submit } from '../../../../../public/LoginImages/importimages';
import { apiurl } from '../../../../../path';
import { formatDateTime, formatDate } from '../../../../../utils/DateFormat';

const TechnicalSanctionApprove = () => {
  const { id } = useParams()
  console.log("id", id);
  const Navigate = useNavigate()
  const context = useContext(AdminContext)
  const [coordinate, setCoordinate] = useState(null)
  const { GetTechnicalInwardsList, TechnicalSanctionApprove } = context
  const [technicalInwards, setTechnicalInwards] = useState([]);
  const [rejectPanelhide, setRejectpanelhide] = useState(1);
  const [remark, setRemark] = useState("");
  const query = new URLSearchParams(useLocation().search);
  const handleBack = () =>{
    const returnPage = query.get('page')||1;
    Navigate(`/AdminDashboard/TechnicalSanctionInwards${returnPage?`?page=${returnPage}`:''}`)
  }

  const getTechnicalInwardsApprove = async () => {
    let data = await GetTechnicalInwardsList('ID', id)
    console.log("data", data);

    setTechnicalInwards(data[0])
    // setFilteredBills(data);
  }

  useEffect(() => {
    if (technicalInwards) {
      // Suppose technicalInwards has Latitude and Longitude fields
      if (technicalInwards.Latitude && technicalInwards.Longitude) {
        setCoordinate(`${technicalInwards.Latitude}/${technicalInwards.Longitude}`);
      }
    }
  }, [technicalInwards]);


  useEffect(() => {
    getTechnicalInwardsApprove()
  }, [])

  const ApproveSanction = async (condition) => {
    const confirmed = window.confirm("Are you sure?");
    if (!confirmed) return;
          if(condition=="Rejected"||condition=="SendBack"){
                const cleanRemark = remark.trim().replace(/\s+/g, " ");

    // ❌ If remark is empty after trimming
    if (!cleanRemark) {
        alert("Remark is required and cannot be empty!");
        return;
    }}
    try {
      let data = await TechnicalSanctionApprove(id, condition, remark);
      console.log("data");

      if (data?.message) {
        alert(data?.message)
        Navigate('/AdminDashboard/TechnicalSanctionInwards')
      } else {
        alert(data?.message)
        Navigate('/AdminDashboard/TechnicalSanctionInwards')
      }
    } catch (error) {
      console.error(`${condition} error:`, error);
      alert("An error occurred during" + condition);
    }
  }
  const navigatetoMap = () => {
    // e.preventDefault();
console.log("GPCode:", technicalInwards.GPCode);
  console.log("DPCode:", technicalInwards.DPCode);
  console.log("TechnicalSanctionNo:", technicalInwards.TechnicalSanctionNo);
  console.log("Proposal_UID:", technicalInwards.Proposal_UID);
  console.log("GR_UID:", technicalInwards.GR_UID);
  console.log("MultipleGramPanchayat:", technicalInwards.MultipleGramPanchayat);
    if (technicalInwards.MultipleGramPanchayat === "Yes") {
      const fetchurl = `https://grammanchitra.gov.in/gpassetsCollectionMH?dpcode=${technicalInwards.DPCode}&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYmYiOjE3MTcxNDM5OTksImV4cCI6MTcxNzE1MTE5OSwiaXNzIjoiaHR0cHM6Ly9sb2NhbGhvc3Q6NzAzNC8iLCJhdWQiOiJodHRwczovL2xvY2FsaG9zdDo3MDM0LyJ9.Yb3a_9eB5DEC9OeGfO7GoUgqxnhfRDF6fZMHdPhW3hg&activityCode=${technicalInwards.TechnicalSanctionNo}&forRddAssetCode=true&projectId=${technicalInwards.Proposal_UID}&rddassetCode=${technicalInwards.GR_UID}`;
      console.log("FINAL URL:", fetchurl);
      window.open(fetchurl, "_blank");
    }
    
    else if (technicalInwards.MultipleGramPanchayat === "No"){
    const fetchurl = `https://grammanchitra.gov.in/gpassetsCollectionMH?gpcode=${technicalInwards.GPCode}&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYmYiOjE3MTcxNDM5OTksImV4cCI6MTcxNzE1MTE5OSwiaXNzIjoiaHR0cHM6Ly9sb2NhbGhvc3Q6NzAzNC8iLCJhdWQiOiJodHRwczovL2xvY2FsaG9zdDo3MDM0LyJ9.Yb3a_9eB5DEC9OeGfO7GoUgqxnhfRDF6fZMHdPhW3hg&activityCode=${technicalInwards.TechnicalSanctionNo}&forRddAssetCode=true&projectId=${technicalInwards.Proposal_UID}&rddassetCode=${technicalInwards.GR_UID}`;
   console.log("FINAL URL:", fetchurl);
    window.open(fetchurl, "_blank");
    }
 
  };

  return (

    <>

      <div className="col-12" style={{ height: "90vh", overflowY: "scroll", overflowX: "hidden" }}>

        <div className="col-12 col-md-10 m-auto my-3">
          <button className="btn btn-danger d-inline-flex align-items-center gap-2 px-3 py-1 rounded-pill shadow-sm back-button"
            onClick={handleBack}
          >
            <span style={{ fontSize: "1.2rem" }}>&larr;</span>
            <span style={{ fontWeight: "500" }}>Back</span>
          </button>
        </div>

        <div style={{ display: "grid", justifyContent: "center", marginTop: "1rem", marginBottom: "5rem" }}>
          {/* <h3>TechnicalSanctionApprove</h3> */}

          <div className="bill-container" id="container" >
            <div className="bill-header">
              {/* <div>
              <img src="/logo1.png" alt="..." style={{ width: "100px" }} />
            </div> */}
              <div style={{ color: "red" }} className="municipal-council">
                <h4>Single Unified Portal</h4>
              </div>
              <div className="form">(Rural Development Department)</div>
              <div className="bill-title">Zila Parishad</div>
            </div>

            <div className="estate-details">
              {/* <div className="estate-code"> */}
              Technical Sanction ID: {technicalInwards?.TS_ID}

              {/* </div> */}
              <div className="ward">Date Time: {formatDateTime(technicalInwards?.Date)}</div>
            </div>

            <div style={{ border: "1px black solid", padding: "5px", backgroundColor: "#e9f8f1" }}>
              <div className="innerheader" style={{ display: "flex", justifyContent: "center" }}>
                <div>Technical Sanction Details</div>
              </div>

            </div>
            <div style={{ border: "1px black solid", display: "hidden" }}>
              {/* <div className="tax-details-title" style={{ textAlign: "center" }}>Details of Taxes</div> */}
              <div className="tax-table" >
                <table className="table table-striped tax-table-data">
                  <thead className="table-dark">

                  </thead>
                  <tbody>
                    <tr>
                      <td style={{ width: "25%" }}><b>Technical Sanction UID</b></td>
                      <td align="center" style={{ width: "25%" }}><span id="lbl_genTax2">{technicalInwards?.TS_ID}</span></td>
                    </tr>
                    <tr>
                      <td style={{ width: "25%" }}><b> MHUID Number</b></td>
                      <td align="center" style={{ width: "25%" }}><span id="lbl_genTax2">{technicalInwards?.TechnicalSanctionNo}</span></td>
                    </tr>
                    <tr>
                      <td style={{ width: "25%" }}><b>HeadCode</b> </td>
                      <td align="center" style={{ width: "25%" }}><span id="lbl_genTax2">{technicalInwards.HeadCode}</span></td>
                    </tr>
                    <tr>
                      <td style={{ width: "25%" }}><b>Sanction Year</b></td>
                      <td align="center" style={{ width: "25%" }}><span id="lbl_genTax2">{technicalInwards.SanctionYear}</span></td>
                    </tr>
                    <tr>
                      <td style={{ width: "25%" }}><b>Zila Parishad</b> </td>
                      <td align="center" style={{ width: "25%" }}> <span id="lbl_genTax2">{technicalInwards.District}</span> </td>
                    </tr>
                    <tr>
                      <td style={{ width: "25%" }}> <b>Taluka</b></td>
                      <td align="center" style={{ width: "25%" }}><span id="lbl_genTax2">{technicalInwards.Taluka}</span></td>
                    </tr>
                    <tr>
                      <td style={{ width: "25%" }}> <b>Constituency Name</b></td>
                      <td align="center" style={{ width: "25%" }}><span id="lbl_genTax2">{technicalInwards.ConstituencyName}</span></td>
                    </tr>
                    <tr>
                      <td style={{ width: "25%" }}> <b>Gram Panchayat</b></td>
                      <td align="center" style={{ width: "25%" }}><span id="lbl_genTax2">{technicalInwards.GramPanchayat}</span></td>
                    </tr>
                    {/* <tr>
                    <td style={{ width: "25%" }}> <b>Village</b></td>
                    <td align="center" style={{ width: "25%" }}><span id="lbl_genTax2">{technicalInwards.Village}</span></td>
                  </tr> */}
                    <tr>
                      <td style={{ width: "25%" }}> <b>Work Name</b></td>
                      <td align="center" style={{ width: "25%" }}><span id="lbl_genTax2">{technicalInwards.WorkName}</span></td>
                    </tr>
                      <tr>
                    <td style={{ width: "25%" }}> <b>Job ID</b></td>
                    <td align="center" style={{ width: "25%" }}><span id="lbl_genTax2">{technicalInwards.JOB_ID}</span></td>
                  </tr>
                    <tr>
                      <td style={{ width: "25%" }}> <b>Type of Work</b></td>
                      <td align="center" style={{ width: "25%" }}><span id="lbl_genTax2">{technicalInwards.TypeofWork} </span></td>
                    </tr>
                    <tr>
                      <td style={{ width: "25%" }}> <b>Technical Sanction Amount</b></td>
                      <td align="center" style={{ width: "25%" }}><span id="lbl_genTax2">{technicalInwards.TechnicalSanctionAmt}</span></td>
                    </tr>
                    <tr>
                      <td style={{ width: "25%" }}> <b>Multiple Gram Panchayat</b></td>
                      <td align="center" style={{ width: "25%" }}><span id="lbl_genTax2">{technicalInwards.MultipleGramPanchayat}</span></td>
                    </tr>
                    <tr>
                      <td style={{ width: "25%" }}> <b>Co-Ordinates</b></td>
                      <td align="center" style={{     width: "25%",
    maxWidth: "250px",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    whiteSpace: "normal", }}><span id="lbl_genTax2">{technicalInwards.Area}</span></td>
                    </tr>
                    <tr>
                      <td style={{ width: "25%" }}> <b>Remark(if Overlapping co-ordinates)</b></td>
                      <td align="center" style={{ width: "25%" }}><span id="lbl_genTax2">{technicalInwards.Area_Remark? technicalInwards.Area_Remark : "NA"}</span></td>
                    </tr>
                    <tr>
                      <td style={{ width: "25%" }}> <b>GR Approved Copy</b></td>
                      <td align="center" style={{ width: "25%" }}>
                        {
                          technicalInwards.GRDraftCopy ? (
                            <>

                              <div className='m-auto' style={{ display: "flex", alignItems: "center", gap: "0.20rem" }}>
                                <img src="/pdf-32.png" alt="pdf" style={{ width: "1.3rem", height: "1.3rem" }} />
                                <a
                                  href={`${apiurl}/GRDraftCopy/${technicalInwards.GRDraftCopy}`}
                                  target="_blank"
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "600",
                                    color: "#357EDC",
                                    whiteSpace: "wrap",
                                    textAlign: "justify"
                                  }}
                                  title={technicalInwards.GRDraftCopy}
                                >
                                  {technicalInwards.GRDraftCopy}
                                </a>
                              </div>
                            </>

                          ) : (
                            <div className='m-auto' style={{ display: "flex", alignItems: "center", gap: "0.20rem", justifyContent: "center", width: "fit-content" }}>
                              <img src="/No-File32.png" alt="no file" style={{ width: "1.3rem", height: "1.3rem" }} />
                              <span className='text-danger fw-bold'>No File</span>
                            </div>
                          )
                        }</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className='col-12' style={{ border: "1px black solid", padding: "5px", backgroundColor: "#e9f8f1" }}>
              <div className="col-10 m-auto">

                {/* <button className='btn btn-primary' onClick={(e)=>setCoordinate("18.59584/73.7869824")}>get coordinate:{coordinate} </button> */}
                <div className="col-10 m-auto text-center my-3">
                  {
                    technicalInwards.Area ? (
                      <button className='btn btn-success px-5 py-2' onClick={navigatetoMap}>Go To Map</button>
                    )
                      :
                      (
                        <p className='text-danger fw-bold'>No Location Found </p>
                      )
                  }

                </div>
              </div>
            </div>


            <div style={{ border: "1px black solid", padding: "5px", backgroundColor: "#e9f8f1" }}>
              <div className="innerheader" style={{ display: "flex", justifyContent: "center" }}>
                <div>Declaration</div>
              </div>
              <div className="note">
                I hereby declare that the information given above and in the enclosed documents is true to the best of my knowledge
              </div>
            </div>
            <div className='my-3' style={{ display: "flex", justifyContent: "center" }}>
              <div>
                <button className='btn btn-success' onClick={() => ApproveSanction("Approved")}>Approve</button>
                <button className='btn btn-danger mx-3' onClick={() => setRejectpanelhide(2)}>Reject</button>
                {/* <button className='btn btn-warning ' onClick={() => setRejectpanelhide(3)}>Send Back</button> */}
              </div>
            </div>
          </div>

        </div>

      </div>



      {
        rejectPanelhide === 2 &&

        <div className='col-12 RejectPanelContainer'>
          <div className="Rejectpanel">
            <form action="">

              <div className="col-12 elements">
                <div className="row">
                  <div className="col-3">
                    <label className='fw-bold'>Remark <span className='text-danger'>*</span></label>
                  </div>
                  <div className="col-8">
                    <textarea name="" id="" placeholder='Enter Remark' value={remark} onChange={(e) => setRemark(e.target.value.replace(/^\s+/, ""))}>
                    </textarea>
                  </div>
                </div>
              </div>

            </form>
            <div className="col-12 ms-auto my-4">
              <div className="row">
                {/* <div className="col-3"></div> */}
                <div className="col-9 m-auto">
                  <div className="col-12" style={{ display: 'flex', gap: '10px', justifyContent: "center" }}>
                    <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '5rem', height: '2rem', fontSize: '18px' }} onClick={() => ApproveSanction("Rejected")}><img src={submit} style={{ width: '15px' }} /> Reject</button>
                    <button type="button" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', backgroundColor: '#f1594c', width: '6rem', height: '2rem', fontSize: '16px' }} onClick={() => window.location.reload()}> <img src={Cancel32} style={{ width: '17px' }} />Cancel</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

      }

      {
        rejectPanelhide === 3 &&

        <div className='col-12 RejectPanelContainer'>
          <div className="Rejectpanel">
            <form action="">

              <div className="col-12 elements">
                <div className="row">
                  <div className="col-3">
                    <label className='fw-bold'>Remark <span className='text-danger'>*</span></label>
                  </div>
                  <div className="col-8">
                    <textarea name="" id="" placeholder='Enter Remark' value={remark} onChange={(e) => setRemark(e.target.value.replace(/^\s+/, ""))}>
                    </textarea>
                  </div>
                </div>
              </div>

            </form>
            <div className="col-12 ms-auto my-4">
              <div className="row">
                {/* <div className="col-3"></div> */}
                <div className="col-9 m-auto">
                  <div className="col-12" style={{ display: 'flex', gap: '10px', justifyContent: "center" }}>
                    <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '8rem', height: '2rem', fontSize: '18px' }} onClick={() => ApproveSanction("SendBack")}><img src={submit} style={{ width: '15px' }} /> Send Back</button>
                    <button type="button" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', backgroundColor: '#f1594c', width: '6rem', height: '2rem', fontSize: '16px' }} onClick={() => window.location.reload()}> <img src={Cancel32} style={{ width: '17px' }} />Cancel</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

      }
    </>
  )
}

export default TechnicalSanctionApprove;
